// src/api/langfuse.ts
import { Langfuse } from "langfuse";

// export const lf = new Langfuse({
//   secretKey: process.env.LANGFUSE_SECRET_KEY!,
//   baseUrl: process.env.LANGFUSE_BASEURL!,
// });

export const lf = new Langfuse({
  secretKey: process.env.REACT_APP_LANGFUSE_SECRET_KEY!,
  publicKey: process.env.REACT_APP_LANGFUSE_PUBLIC_KEY!,
  baseUrl: process.env.REACT_APP_LANGFUSE_BASE_URL!,
});


export async function fetchPromptsOnStartup() {
    try {
      // Fetch and cache the production version of the prompt
      await lf.getPrompt("first_analysis");
    } catch (error) {
      console.error("Failed to fetch prompt on startup:", error);
      process.exit(1); // Exit the application if the prompt is not available
    }
  }
   